'use client';

import React, { useEffect, useState } from "react";

const ChatPopup = () => {
  const [isTawkLoaded, setIsTawkLoaded] = useState(false);

  useEffect(() => {
    // Prevent script from loading multiple times
    if (document.getElementById("tawk-script")) {
      setIsTawkLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.id = "tawk-script";
    script.async = true;
    script.src = "https://embed.tawk.to/670c169a4304e3196ad11209/1ia3jgj2b";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    script.onload = () => {
      setIsTawkLoaded(true);

      // Safe visibility control
      const handleWidgetVisibility = () => {
        if (window.Tawk_API) {
          if (window.innerWidth < 1024) {
            window.Tawk_API.hideWidget();
          } else {
            window.Tawk_API.showWidget();
          }
        }
      };

      handleWidgetVisibility();
      window.addEventListener("resize", handleWidgetVisibility);
    };

    document.body.appendChild(script);

    return () => {
      window.removeEventListener("resize", () => {});
      const existingScript = document.getElementById("tawk-script");
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const openChat = () => {
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
    } else {
      console.warn("Tawk.to not ready yet.");
    }
  };

  return (
    <button
      onClick={openChat}
      aria-label="Open Chat"
      className="absolute left-0 fixed top-2/4 transform -translate-y-2/4 shadow-lg cursor-pointer z-30 md:hidden xl:hidden"
      style={{
        position: "fixed",
        top: "50%",
        left: "0",
        transform: "translateY(-50%)",
        zIndex: 30,
        width: "40px",
        height: "100px",
      }}
    >
      <div
        className="flex flex-col items-center justify-center bg-pink-600 rounded-tr-lg p-1 text-gray-700"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div className="flex flex-col items-center">
          <span className="text-lg mb-1 text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 800"
              height="24px"
              width="24px"
              role="img"
              className="tawk-min-chat-icon"
            >
              <path
                fill="white"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z"
              ></path>
            </svg>
          </span>
        </div>
        <div
          className="flex flex-col items-center"
          style={{
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            marginTop: "5px",
          }}
        >
          <span className="px-1 text-sm font-bold text-white mb-1">
            Chat
          </span>
        </div>
      </div>
    </button>
  );
};

export default ChatPopup;
